// const baseUrl = "http://localhost:8201";
// const baseUrl = "https://instructor.teachera.co";
const baseUrl = "https://api.employscope.com";
export { baseUrl };

//perchese
//active InActive in videoList
